import Vue from 'vue'
import template from './index.pug'

// @vue/component
export default Vue.extend({
  template: template(),

  props: {
    fare: {
      type: Object,
      default: () => {}
    }
  },

  methods: {
    lineName(line) {
      if (line.has_transfers) {
        return `${line.name} *`
      }
      return line.name
    },

    showPossibleTransfers(lines) {
      return lines.some(line => line.has_transfers)
    }
  }
})
